/* eslint-disable react/prop-types */
import React, { useMemo } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { useStyles } from "./template.style";

export const TextEditor = (props) => {
  const classes = useStyles();
  const {
    tinyMceKey,
    placeholder,
    initialValue,
    emailBodyChange,
    height = 200,
    requiredPlugins = "lists",
    requiredToolBars = "undo redo | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent |  forecolor backcolor emoticons"
  } = props;

  const tinyMcOptions = useMemo(() => {
    return {
      height,
      selector: "textarea",
      resize: false,
      branding: false,
      statusbar: false,
      menubar: false,
      placeholder,
      plugins: requiredPlugins,
      toolbar: requiredToolBars
    };
  }, [requiredPlugins, requiredToolBars, placeholder, height]);

  const handleEditorChange = (newContent) => {
    emailBodyChange(newContent);
  };

  return (
    <div className={classes.textAreaDescriptionWrapper}>
      <Editor
        apiKey={tinyMceKey}
        // tinymceScriptSrc={`${process.env.PUBLIC_URL}/tinymce/tinymce.min.js`}
        value={initialValue}
        init={tinyMcOptions}
        onEditorChange={handleEditorChange}
      />
    </div>
  );
};
